import React from 'react';
import { CardViewContentProps } from './types';
import { Box, Typography } from '@mui/material';
import LibraryCategoryCard from '../../../../common/library-category-card/LibraryCategoryCard';
import ApartmentOutlinedIcon from '../../../../../static/assets/svg/apartment.svg';
import BadgeOutlinedIcon from '../../../../../static/assets/svg/badge-light.svg';
import SupportAgentOutlinedIcon from '../../../../../static/assets/svg/support-agent.svg';
import BusinessCenterIcon from '../../../../../static/assets/svg/business-center-v2.svg';
import { useTranslation } from 'react-i18next';
import LibraryList from '../library-list/LibraryList';
import styles from '../../scss/Library.module.scss';
import { BusinessCategoryContent } from './BusinessCategoryContent';
import { EmploymentCategoryContent } from './EmploymentCategoryContent';
import { CustomersCategoryContent } from './CustomersCategoryContent';
import { SuppliersCategoryContent } from './SuppliersCategoryContent';

export const CardViewContent = ({
  activeTab,
  changeTabFunction,
  templates,
  workflow,
  setWorkflow,
}: CardViewContentProps) => {
  const { t } = useTranslation();
  if (activeTab === 'All') {
    return (
      <>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
            gap: '24px',
            backgroundColor: 'transparent',
            flexWrap: 'wrap',
          }}
        >
          <LibraryCategoryCard
            title={t('Business')}
            onClick={() => changeTabFunction('Business')}
            icon={<ApartmentOutlinedIcon />}
          />
          <LibraryCategoryCard
            title={t('Employment')}
            onClick={() => changeTabFunction('Employment')}
            icon={<BadgeOutlinedIcon />}
          />
          <LibraryCategoryCard
            title={t('Customers')}
            onClick={() => changeTabFunction('Customers')}
            icon={<SupportAgentOutlinedIcon />}
          />
          <LibraryCategoryCard
            title={t('Suppliers')}
            onClick={() => changeTabFunction('Suppliers')}
            icon={<BusinessCenterIcon />}
          />
        </Box>
      </>
    );
  }
  if (!workflow) {
    if (activeTab === 'Business') {
      return <BusinessCategoryContent templates={templates} setWorkflow={setWorkflow} />;
    } else if (activeTab === 'Employment') {
      return <EmploymentCategoryContent templates={templates} setWorkflow={setWorkflow} />;
    } else if (activeTab === 'Customers') {
      return <CustomersCategoryContent templates={templates} setWorkflow={setWorkflow} />;
    } else if (activeTab === 'Suppliers') {
      return <SuppliersCategoryContent templates={templates} setWorkflow={setWorkflow} />;
    }
  } else {
    return (
      <>
        <Box className={styles.breadcrumbs}>
          <Typography
            variant='h3'
            component='h3'
            className={styles.documentViewText}
            onClick={() => setWorkflow(null)}
          >
            {t('headers.workflows')}
          </Typography>
          <Typography variant='body2' className={styles.separator}>
            ›
          </Typography>
          <Typography variant='body2' className={styles.documentViewText}>
            {workflow}
          </Typography>
        </Box>
        <LibraryList
          cardView={true}
          libraryItems={[...templates]
            .filter(
              (el) =>
                'category' in el &&
                el.category === activeTab &&
                'dl_workflows' in el &&
                el.dl_workflows.includes(workflow)
            )
            .sort((a, b) => a.name.localeCompare(b.name))}
        />
      </>
    );
  }
};
